import compact from 'lodash/compact';

export const DESCRIPTION_SEPARATOR = ' — ';

// A bib whose localization level is UNMATCHED has not been matched to a shared work record, so the
// page is a thin duplicate of others and should be kept out of search indexes.
export const NO_INDEX_LOCALIZATION_LEVEL = 'UNMATCHED';

/**
 * Derives the props for the bib page's `<DocumentHeadContainer>` — page title, social/meta
 * description, cover image, canonical URL and the noIndex flag.
 *
 * Extracted from BibPageContainer.renderDocumentHead so the derivation can be tested directly
 * (CORE-78542). The page itself cannot be mounted under RTL — its connected section subtree needs
 * the whole bib-page state surface — and the enzyme test it replaces only asserted that
 * `DocumentHeadContainer` was present, never what it was given.
 *
 * @param {Immutable.Map} catalogBib the current bib
 * @param {*}             linkedData schema.org graph, passed through untouched
 * @param {string}        baseURL    site base URL, from app context
 * @returns {object} props for DocumentHeadContainer
 */
export default function buildDocumentHeadProps(catalogBib, linkedData, baseURL) {
  const pageTitle = catalogBib.getIn(['brief', 'title']);
  const authorName = catalogBib.getIn(['brief', 'creators', 0, 'fullName']);

  return {
    pageTitle,
    // `compact` drops a missing author or description rather than leaving an empty segment, so a
    // bib with no author reads "Title — Description" instead of "Title —  — Description".
    description: compact([pageTitle, authorName, catalogBib.getIn(['brief', 'description'])]).join(
      DESCRIPTION_SEPARATOR
    ),
    imageUrl: catalogBib.getIn(['brief', 'coverImage', 'large']),
    linkedData,
    pageUrl: `${baseURL}/v2/record/${catalogBib.get('metadataId')}`,
    noIndex: catalogBib.get('localizationLevel') === NO_INDEX_LOCALIZATION_LEVEL
  };
}
